// Accurafil LCC Calculator - Shopify Compliant JavaScript with Google Charts

// AccuraFil Filter Models Data from CSV - Global scope
const accurafil_models_data = {
  
  "AccuraFil-Pleat-Panel-1\"-M13": {
    "Filter Size": "24\" x 24\" x 1\"",
    "Filter Price": 10,
    "Initial Pressure Drop": 0.32,
    "Average Pressure Drop": 0.607,
    "Filter Lifespan (months)": 3,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-13"
  },
  "AccuraFil-Pleat-Panel-2\"-M13": {
    "Filter Size": "24\" x 24\" x 2\"",
    "Filter Price": 15,
    "Initial Pressure Drop": 0.313,
    "Average Pressure Drop": 0.605,
    "Filter Lifespan (months)": 6,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-13"
  },
    "AccuraFil-Minipleat_Syn_Panel_(ABS)_2\"-M13": {
    "Filter Size": "24\" x 24\" x 2\"",
    "Filter Price": 45,
    "Initial Pressure Drop": 0.378,
    "Average Pressure Drop": 0.855,
    "Filter Lifespan (months)": 6,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-14"
  },
  "AccuraFil-Minipleat_Syn_Panel_(ABS)_2\"-M15": {
    "Filter Size": "24\" x 24\" x 2\"",
    "Filter Price": 54,
    "Initial Pressure Drop": 0.378,
    "Average Pressure Drop": 0.855,
    "Filter Lifespan (months)": 3,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-15"
  },
  "AccuraFil-Minipleat_Syn_Panel_(ABS)_4\"-M15": {
    "Filter Size": "24\" x 24\" x 4\"",
    "Filter Price": 73,
    "Initial Pressure Drop": 0.279,
    "Average Pressure Drop": 0.82,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-15"
  },
  "AccuraFil-Minipleat_Syn_Panel_(Metal)_2\"-M13": {
    "Filter Size": "24\" x 24\" x 2\"",
    "Filter Price": 75,
    "Initial Pressure Drop": 0.262,
    "Average Pressure Drop": 0.88,
    "Filter Lifespan (months)": 6,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-15"
  },
  "AccuraFil-Minipleat_Syn_Panel_(Metal)_4\"-M14": {
    "Filter Size": "24\" x 24\" x 4\"",
    "Filter Price": 125,
    "Initial Pressure Drop": 0.561,
    "Average Pressure Drop": 0.957,
    "Filter Lifespan (months)": 6,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-15"
  },
    "AccuraFil-4V-Bank_Carbon_M13": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 399.4,
    "Initial Pressure Drop": 0.617,
    "Average Pressure Drop": 0.985,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-13"
  },
  "AccuraFil-4V-Bank_Carbon_M15": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 322,
    "Initial Pressure Drop": 0.568,
    "Average Pressure Drop": 0.968,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-15"
  },
  "AccuraFil-4V-Bank_Syn_M15": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 123,
    "Initial Pressure Drop": 0.249,
    "Average Pressure Drop": 0.78,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-15"
  },
  "AccuraFil-4V-Bank_Syn_M16": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 129,
    "Initial Pressure Drop": 0.252,
    "Average Pressure Drop": 0.884,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-16A"
  },
  "AccuraFil-4V-Bank_FG_M14": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 112,
    "Initial Pressure Drop": 0.388,
    "Average Pressure Drop": 0.855,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-14"
  },
  "AccuraFil-4V-Bank_FG_M15": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 112,
    "Initial Pressure Drop": 0.459,
    "Average Pressure Drop": 0.915,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-15"
  },
    "AccuraFil-HEPA SC-FG-H13": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 240,
    "Initial Pressure Drop": 0.853,
    "Average Pressure Drop": 1.43,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1200,
    "Efficiency Rating": "H13 / 99.99%"
  },
  "AccuraFil-HEPA HC_FG_H13": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 273,
    "Initial Pressure Drop": 1.265,
    "Average Pressure Drop": 1.633,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1700,
    "Efficiency Rating": "H13 / 99.99%"
  },
  "AccuraFil-HEPA HV XL_FG_5V_H13": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 279,
    "Initial Pressure Drop": 1.307,
    "Average Pressure Drop": 1.655,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 2000,
    "Efficiency Rating": "H13 / 99.99%"
  },
  "AccuraFil-HEPA HV XL_FG_6V_H13": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 550,
    "Initial Pressure Drop": 1.088,
    "Average Pressure Drop": 1.52,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 2400,
    "Efficiency Rating": "H13 / 99.99%"
  },
  "AccuraFil-Ashrae Cell_FG_M14": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 149,
    "Initial Pressure Drop": 0.421,
    "Average Pressure Drop": 0.875,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-14"
  },
  "AccuraFil-Rigid Pac_Syn_M15": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 113,
    "Initial Pressure Drop": 0.531,
    "Average Pressure Drop": 0.938,
    "Filter Lifespan (months)": 6,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-15"
  },
  "AccuraFil-8-Pocket_Syn_22\"L-M13": {
    "Filter Size": "24\" x 24\" x 22\"",
    "Filter Price": 40,
    "Initial Pressure Drop": 0.287,
    "Average Pressure Drop": 0.886,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-13"
  },
  "AccuraFil-8-Pocket_Syn_22\"L-M14": {
    "Filter Size": "24\" x 24\" x 22\"",
    "Filter Price": 44,
    "Initial Pressure Drop": 0.396,
    "Average Pressure Drop": 0.855,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-14"
  },
  "AccuraFil-8-Pocket_Syn_22\"L-M15": {
    "Filter Size": "24\" x 24\" x 22\"",
    "Filter Price": 47,
    "Initial Pressure Drop": 0.431,
    "Average Pressure Drop": 0.877,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-15"
  },
    "Viskon-8-Pocket_22\"L-AS-M14-22": {
    "Filter Size": "24\" x 24\" x 22\"",
    "Filter Price": 65,
    "Initial Pressure Drop": 0.231,
    "Average Pressure Drop": 0.7733,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-14",
    "Dust Holding Capacity (grams)": 212.1
  },
  "Viskon-8-Pocket_22\"L-AS-M15-22": {
    "Filter Size": "24\" x 24\" x 22\"",
    "Filter Price": 65,
    "Initial Pressure Drop": 0.4,
    "Average Pressure Drop": 0.9533,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-15",
    "Dust Holding Capacity (grams)": 122.0
  },
  "Viskon-8-Pocket_22\"L-FG-M11-22": {
    "Filter Size": "24\" x 24\" x 22\"",
    "Filter Price": 65,
    "Initial Pressure Drop": 0.28,
    "Average Pressure Drop": 0.916,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-11",
    "Dust Holding Capacity (grams)": 491.0
  },
  "Viskon-8-Pocket_22\"L-FG-M13-22": {
    "Filter Size": "24\" x 24\" x 22\"",
    "Filter Price": 65,
    "Initial Pressure Drop": 0.48,
    "Average Pressure Drop": 0.913,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-13",
    "Dust Holding Capacity (grams)": 317.0
  },
  "Viskon-8-Pocket_22\"L-FG-M15-22": {
    "Filter Size": "24\" x 24\" x 22\"",
    "Filter Price": 65,
    "Initial Pressure Drop": 0.61,
    "Average Pressure Drop": 0.988,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-15",
    "Dust Holding Capacity (grams)": 230.0
  },
  "Viskon-4V-FG-M13": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 250,
    "Initial Pressure Drop": 0.31,
    "Average Pressure Drop": 0.811,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-13",
    "Dust Holding Capacity (grams)": 313.0
  },
  "Viskon-4V-FG-M14": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 250,
    "Initial Pressure Drop": 0.34,
    "Average Pressure Drop": 0.828,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-14",
    "Dust Holding Capacity (grams)": 469.0
  },
  "Viskon-4V-FG-M15": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 250,
    "Initial Pressure Drop": 0.4,
    "Average Pressure Drop": 0.867,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-15",
    "Dust Holding Capacity (grams)": 403.0
  },
  "Viskon-4V-FG-M16": {
    "Filter Size": "24\" x 24\" x 12\"",
    "Filter Price": 250,
    "Initial Pressure Drop": 0.55,
    "Average Pressure Drop": 0.953,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-16",
    "Dust Holding Capacity (grams)": 403.0
  },
  "Viskon-8-Pocket-RV-M11-22": {
    "Filter Size": "24\" x 24\" x 22\"",
    "Filter Price": 65,
    "Initial Pressure Drop": 0.183,
    "Average Pressure Drop": 0.7517,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-11",
    "Dust Holding Capacity (grams)": 385.4
  },
  "Viskon-8-Pocket-RV-M13A-22": {
    "Filter Size": "24\" x 24\" x 22\"",
    "Filter Price": 65,
    "Initial Pressure Drop": 0.37,
    "Average Pressure Drop": 0.848,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-13A",
    "Dust Holding Capacity (grams)": 253.0
  },
  "Viskon-8-Pocket-RV-M15-22": {
    "Filter Size": "24\" x 24\" x 22\"",
    "Filter Price": 65,
    "Initial Pressure Drop": 0.5,
    "Average Pressure Drop": 0.9217,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-14",
    "Dust Holding Capacity (grams)": 311.6
  },
  "Viskon-8-Pocket-RV-M16A-22": {
    "Filter Size": "24\" x 24\" x 22\"",
    "Filter Price": 65,
    "Initial Pressure Drop": 0.34,
    "Average Pressure Drop": 0.92,
    "Filter Lifespan (months)": 12,
    "Filter Airflow Rate (CFM)": 1968,
    "Efficiency Rating": "MERV-16A",
    "Dust Holding Capacity (grams)": 316.4
  }
};

document.addEventListener("DOMContentLoaded", function() {
  console.log("LCC Calculator DOM loaded - Start");
  
  // AccuraFil Filter Models Data from CSV
  
  // Load Google Charts
  google.charts.load('current', {'packages':['corechart']});
  
  // Check if Chart.js is loaded for comparison chart
  setTimeout(function() {
    if (typeof Chart === 'undefined') {
      console.log('Chart.js not loaded, attempting to load from alternate CDN');
      var chartScript = document.createElement('script');
      chartScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/3.9.1/chart.min.js';
      chartScript.onload = function() {
        console.log('Chart.js loaded from alternate CDN');
        initCalculator();
      };
      chartScript.onerror = function() {
        console.error('Failed to load Chart.js from alternate CDN');
        document.getElementById('loading-message').textContent = 'Could not load Chart.js. Please refresh the page or try a different browser.';
        // Initialize calculator anyway, but without comparison charts
        initCalculator();
      };
      document.head.appendChild(chartScript);
    } else {
      console.log('Chart.js already loaded');
      initCalculator();
    }
  }, 1000);
  
  function initCalculator() {
    console.log("Initializing LCC Calculator - Start");
    
    // Configuration
    const config = {
      title: 'Accurafil Air Filter Life-Cycle Cost Analysis',
      subtitle: 'Compare the true lifetime cost of Accurafil air filters with competitor products',
      primaryColor: '#006738',
      secondaryColor: '#0078c8'
    };
    
    // State object to store calculator data
    const calculatorState = {
      competitors: [],
      calculationResults: {
        accurafil: null,
        competitors: []
      },
      charts: {
        tcoPieChart: null,
        comparisonChart: null
      }
    };
    
    // Initialize event listeners and dropdown
    initEventListeners();
    initAccurafilDropdown();
    
    // Hide loading spinner
    const loadingOverlay = document.getElementById('loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.classList.add('hidden');
    }
    
    console.log("Calculator initialization complete - End");
    
    // Function to initialize AccuraFil dropdown
    function initAccurafilDropdown() {
      console.log("initAccurafilDropdown called");
      const dropdown = document.getElementById("accurafil-model-dropdown");
      if (dropdown) {
        console.log("AccuraFil dropdown element found.");
        console.log("Populating dropdown with models...");
        // Populate dropdown with model options
        const defaultOption = document.createElement("option");
        defaultOption.value = "";
        defaultOption.textContent = "Select a model...";
        dropdown.appendChild(defaultOption);

        const otherOption = document.createElement("option");
        otherOption.value = "other";
        otherOption.textContent = "Other Model";
        dropdown.appendChild(otherOption);

        Object.keys(accurafil_models_data).forEach(modelKey => {
          const option = document.createElement("option");
          option.value = modelKey;
          option.textContent = modelKey;
          dropdown.appendChild(option);
        });
        
        // Add event listener for dropdown change
        dropdown.addEventListener("change", function() {
          console.log("Dropdown change event fired.");
          const selectedModel = this.value;
          if (selectedModel && accurafil_models_data[selectedModel]) {
            console.log("Selected model: " + selectedModel);
            populateAccurafilFields(accurafil_models_data[selectedModel]);
          } else if (selectedModel === "other") {
            console.log("Selected: Other Model. Populating with default values.");
            populateAccurafilFields({
              "Filter Size": "24\" x 24\" x 12\"",
              "Filter Price": 50,
              "Initial Pressure Drop": 0.42,
              "Average Pressure Drop": 0.64,
              "Filter Lifespan (months)": 12,
              "Filter Airflow Rate (CFM)": 2000,
              "Efficiency Rating": "MERV-14"
            });
            document.getElementById("accurafil-model-text").style.display = "block";
            document.getElementById("accurafil-model-text").value = "Other AccuraFil Model";
          } else {
            console.log("No model selected or model data not found.");
            // Clear fields if no model is selected
            populateAccurafilFields({});
            document.getElementById("accurafil-model-text").style.display = "none";
            document.getElementById("accurafil-model-text").value = "";
          }
        });
      } else {
        console.error("AccuraFil dropdown element not found!");
      }
    }
    
    // Function to populate AccuraFil fields with selected model data
    function populateAccurafilFields(modelData) {
      console.log("Populating AccuraFil fields with data:", modelData);
      const filterSizeField = document.getElementById("filter-size");
      const filterPriceField = document.getElementById("filter-price");
      const initialPressureDropField = document.getElementById("initial-pressure-drop");
      const averagePressureDropField = document.getElementById("average-pressure-drop");
      const filterLifespanField = document.getElementById("filter-lifespan");
      const airflowRateField = document.getElementById("airflow-rate");
      const efficiencyRatingField = document.getElementById("efficiency-rating");
      
      if (filterSizeField) { filterSizeField.value = modelData["Filter Size"] || ""; console.log("Filter Size set to: " + filterSizeField.value); }
      if (filterPriceField) { filterPriceField.value = modelData["Filter Price"] || ""; console.log("Filter Price set to: " + filterPriceField.value); }
      if (initialPressureDropField) { initialPressureDropField.value = modelData["Initial Pressure Drop"] || ""; console.log("Initial Pressure Drop set to: " + initialPressureDropField.value); }
      if (averagePressureDropField) { averagePressureDropField.value = modelData["Average Pressure Drop"] || ""; console.log("Average Pressure Drop set to: " + averagePressureDropField.value); }
      if (filterLifespanField) { filterLifespanField.value = modelData["Filter Lifespan (months)"] || ""; console.log("Filter Lifespan set to: " + filterLifespanField.value); }
      if (airflowRateField) { airflowRateField.value = modelData["Filter Airflow Rate (CFM)"] || ""; console.log("Filter Airflow Rate set to: " + airflowRateField.value); }
      if (efficiencyRatingField) { efficiencyRatingField.value = modelData["Efficiency Rating"] || ""; console.log("Efficiency Rating set to: " + efficiencyRatingField.value); }
    }
    
    // Function to initialize event listeners
    function initEventListeners() {
      console.log('Initializing event listeners');
      
      const calculateBtn = document.getElementById('calculate-btn');
      const calculatorAddCompetitorBtn = document.getElementById('calculator-add-competitor-btn');
      const generatePdfBtn = document.getElementById('generate-pdf-btn');
      const tabs = document.querySelectorAll('.tco-tab');
      const competitorFormsContainer = document.getElementById('competitor-forms-container');
      const calculatorLink = document.querySelector('.calculator-link');
      
      if (tabs) {
        tabs.forEach(tab => {
          tab.addEventListener('click', () => {
            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');
            
            // Hide all content sections
            document.querySelectorAll('.tab-content').forEach(content => {
              content.classList.add('hidden');
            });
            
            // Show selected content section
            const tabName = tab.getAttribute('data-tab');
            const tabContent = document.getElementById(`${tabName}-content`);
            if (tabContent) {
              tabContent.classList.remove('hidden');
            }
            
            // Handle competitor forms visibility based on tab
            if (tabName === 'calculator') {
              // Only show competitor forms in the calculator tab
              if (competitorFormsContainer) {
                competitorFormsContainer.classList.remove('hidden');
              }
              document.querySelectorAll('.competitor-form').forEach(form => {
                form.classList.remove('hidden');
              });
            } else {
              // Hide competitor forms in other tabs
              if (competitorFormsContainer) {
                competitorFormsContainer.classList.add('hidden');
              }
              document.querySelectorAll('.competitor-form').forEach(form => {
                form.classList.add('hidden');
              });
            }
          });
        });
      }
      
      if (calculatorLink) {
        calculatorLink.addEventListener('click', (e) => {
          e.preventDefault();
          const calculatorTab = document.querySelector('.tco-tab[data-tab="calculator"]');
          if (calculatorTab) {
            calculatorTab.click();
          }
        });
      }
      
      if (calculateBtn) {
        calculateBtn.addEventListener('click', () => {
          calculateAllLCC();
          
          // Switch to the comparison tab to show results
          const comparisonTab = document.querySelector('.tco-tab[data-tab="comparison"]');
          if (comparisonTab) {
            comparisonTab.click();
          }
        });
      }
      
      // Add event listener for the calculator tab's Add Competitor button
      if (calculatorAddCompetitorBtn) {
        calculatorAddCompetitorBtn.addEventListener('click', () => {
          if (calculatorState.competitors.length < 3) {
            // Find the next available competitor number
            const nextCompetitorNumber = getNextCompetitorNumber();
            addCompetitorForm(nextCompetitorNumber);
          } else {
            alert('Maximum of 3 competitors can be added for comparison.');
          }
        });
      }
      
      if (generatePdfBtn) {
        generatePdfBtn.addEventListener('click', async function() {
          const loadingOverlay = document.getElementById('loading-overlay');
          if (loadingOverlay) loadingOverlay.classList.remove('hidden');
          
          try {
            const systemParams = {
              numFilters: parseFloat(document.getElementById('num-filters').value),
              airflowRate: parseFloat(document.getElementById('airflow-rate').value),
              operationHours: parseFloat(document.getElementById('operation-hours').value),
              energyCost: parseFloat(document.getElementById('energy-cost').value),
              laborCost: parseFloat(document.getElementById('labor-cost').value),
              disposalCost: parseFloat(document.getElementById('disposal-cost').value),
              fanEfficiency: parseFloat(document.getElementById('fan-efficiency').value),
              analysisPeriod: parseFloat(document.getElementById('analysis-period').value)
            };
            
            // Capture the charts as images
            let pieChartImage = null;
            let comparisonChartImage = null;
            
            // For Google Charts, capture the chart properly with async handling
            if (calculatorState.charts.tcoPieChart) {
              pieChartImage = await captureGoogleChart('tco-pie-chart');
            }
            
            if (calculatorState.charts.comparisonChart) {
              comparisonChartImage = calculatorState.charts.comparisonChart.toBase64Image();
            }
            
            generateLCCPDF(
              calculatorState.calculationResults.accurafil,
              calculatorState.calculationResults.competitors,
              systemParams,
              pieChartImage,
              comparisonChartImage
            );
          } catch (error) {
            console.error('Error generating PDF:', error);
            alert('An error occurred while generating the PDF. Please try again.');
          } finally {
            if (loadingOverlay) loadingOverlay.classList.add('hidden');
          }
        });
      }
      
      console.log('Event listeners initialized');
    }
    
    // Enhanced function to capture Google Chart as SVG and convert to image
    async function captureGoogleChart(chartId) {
      try {
        const chartDiv = document.getElementById(chartId);
        if (chartDiv && calculatorState.charts.tcoPieChart) {
          // Get the chart as SVG
          const svgElement = chartDiv.querySelector('svg');
          if (svgElement) {
            // Create a canvas to convert SVG to image
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const svgData = new XMLSerializer().serializeToString(svgElement);
            
            // Set canvas size to match the chart
            canvas.width = 675;
            canvas.height = 675;
            
            // Create an image from SVG
            const img = new Image();
            const svgBlob = new Blob([svgData], {type: 'image/svg+xml;charset=utf-8'});
            const url = URL.createObjectURL(svgBlob);
            
            return new Promise((resolve) => {
              img.onload = function() {
                // Set white background for the canvas
                ctx.fillStyle = 'white';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                
                // Draw the SVG image
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                const dataURL = canvas.toDataURL('image/png', 1.0);
                URL.revokeObjectURL(url);
                console.log('Google Chart captured successfully');
                resolve(dataURL);
              };
              img.onerror = function() {
                console.error('Failed to load SVG image');
                URL.revokeObjectURL(url);
                resolve(null);
              };
              img.src = url;
            });
          }
        }
      } catch (error) {
        console.error('Error capturing Google Chart:', error);
      }
      return Promise.resolve(null);
    }
    
    // Function to calculate all LCC (AccuraFil and competitors)
    function calculateAllLCC() {
      console.log("calculateAllLCC called");
      
      try {
        // Calculate AccuraFil LCC
        calculateAccurafilLCC();
        
        // Calculate competitor LCC for all existing competitors
        calculatorState.competitors.forEach((competitor, index) => {
          calculateCompetitorLCC(index + 1);
        });
        
        // Update comparison display if competitors exist
        if (calculatorState.competitors.length > 0) {
          updateComparisonDisplay();
        }
        
        console.log('All LCC calculations completed successfully');
      } catch (error) {
        console.error('Error calculating all LCC:', error);
        alert('Error calculating LCC: ' + error.message);
      }
    }
    
    // Function to calculate Accurafil LCC
    function calculateAccurafilLCC() {
      console.log('Calculating Accurafil LCC');
      
      try {
        const selectedModel = document.getElementById('accurafil-model-dropdown').value;
        const filterSize = document.getElementById('filter-size').value;
        const filterPrice = parseFloat(document.getElementById('filter-price').value);
        const initialPressureDrop = parseFloat(document.getElementById('initial-pressure-drop').value);
        const averagePressureDrop = parseFloat(document.getElementById('average-pressure-drop').value);
        const filterLifespan = parseFloat(document.getElementById('filter-lifespan').value);
        const airflowRate = parseFloat(document.getElementById('airflow-rate').value);
        const efficiencyRating = document.getElementById('efficiency-rating').value;
        
        // System parameters
        const numFilters = parseFloat(document.getElementById('num-filters').value);
        const operationHours = parseFloat(document.getElementById('operation-hours').value);
        const energyCost = parseFloat(document.getElementById('energy-cost').value);
        const laborCost = parseFloat(document.getElementById('labor-cost').value);
        const disposalCost = parseFloat(document.getElementById('disposal-cost').value);
        const fanEfficiency = parseFloat(document.getElementById('fan-efficiency').value);
        
        // Validate inputs
        if (isNaN(filterPrice) || isNaN(averagePressureDrop) || isNaN(filterLifespan) || 
            isNaN(airflowRate) || isNaN(numFilters) || isNaN(operationHours) || 
            isNaN(energyCost) || isNaN(laborCost) || isNaN(disposalCost) || isNaN(fanEfficiency)) {
          throw new Error('Please fill in all required fields with valid numbers.');
        }
        
        // Calculate filter changes per year
        const changesPerYear = 12 / filterLifespan;
        
        // Calculate filter cost per filter per year
        const filterCostPerFilterPerYear = filterPrice * changesPerYear;
        
        // Calculate energy cost per filter per year
        const cfmPerFilter = airflowRate;
        const pressureDropInWG = averagePressureDrop;
        const fanPowerHP = (cfmPerFilter * pressureDropInWG) / (6356 * fanEfficiency);
        const fanPowerKW = fanPowerHP * 0.746;
        const energyCostPerFilterPerYear = fanPowerKW * operationHours * energyCost;
        
        // Calculate labor and disposal cost per filter per year
        const laborDisposalCostPerFilterPerYear = (laborCost + disposalCost) * changesPerYear;
        
        // Calculate total cost per filter per year
        const totalCostPerFilterPerYear = filterCostPerFilterPerYear + energyCostPerFilterPerYear + laborDisposalCostPerFilterPerYear;
        
        // Calculate total cost for AHU per year
        const totalCostPerAHUPerYear = totalCostPerFilterPerYear * numFilters;
        
        // Get filter model name - prioritize text input if visible, otherwise use dropdown
        let filterModel;
        const modelTextInput = document.getElementById('accurafil-model-text');
        if (modelTextInput && modelTextInput.style.display !== 'none' && modelTextInput.value.trim()) {
          filterModel = modelTextInput.value.trim();
        } else if (selectedModel && selectedModel !== 'other') {
          filterModel = selectedModel;
        } else {
          filterModel = 'AccuraFil Filter';
        }
        
        calculatorState.calculationResults.accurafil = {
          filterModel,
          filterSize,
          filterPrice,
          changesPerYear,
          averagePressureDrop,
          filterCostPerFilterPerYear,
          energyCostPerFilterPerYear,
          laborDisposalCostPerFilterPerYear,
          totalCostPerFilterPerYear,
          totalCostPerAHUPerYear,
          numFilters,
          initialPressureDrop,
          filterLifespan,
          airflowRate,
          efficiencyRating
        };
        
        updateResultsDisplay(calculatorState.calculationResults.accurafil);
        
        console.log('Accurafil LCC calculated successfully');
      } catch (error) {
        console.error('Error calculating Accurafil LCC:', error);
        alert('Error calculating LCC: ' + error.message);
      }
    }
    
    // Function to update results display
    function updateResultsDisplay(results) {
      console.log('Updating results display');
      
      const formatCurrency = (value) => value ? '$' + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : '$0.00';
      const formatNumber = (value, decimals = 2) => value ? value.toFixed(decimals) : '0.00';
      
      // Update the LCC results table
      document.getElementById('filter-model-result').textContent = results.filterModel;
      document.getElementById('filter-price-result').textContent = formatCurrency(results.filterPrice);
      document.getElementById('changes-per-year').textContent = formatNumber(results.changesPerYear);
      document.getElementById('average-pressure-drop-result').textContent = formatNumber(results.averagePressureDrop);
      document.getElementById('energy-cost-result').textContent = formatCurrency(results.energyCostPerFilterPerYear);
      document.getElementById('labor-disposal-cost').textContent = formatCurrency(results.laborDisposalCostPerFilterPerYear);
      document.getElementById('total-cost-per-filter').textContent = formatCurrency(results.totalCostPerFilterPerYear);
      document.getElementById('total-cost').textContent = formatCurrency(results.totalCostPerAHUPerYear);
      
      // Update Google Charts 3D pie chart with proper callback
      google.charts.setOnLoadCallback(function() {
        updateGooglePieChart(results);
      });
      
      console.log('Results display updated');
    }
    
    // Function to update Google Charts 3D pie chart
    function updateGooglePieChart(results) {
      console.log('Updating Google Charts 3D pie chart');
      
      try {
        // Wait for Google Charts to be ready
        if (typeof google === 'undefined' || !google.visualization) {
          console.log('Google Charts not ready, retrying...');
          setTimeout(() => updateGooglePieChart(results), 500);
          return;
        }
        
        // Calculate the per-filter costs and percentages
        const filterCostPerFilter = results.filterCostPerFilterPerYear;
        const energyCostPerFilter = results.energyCostPerFilterPerYear;
        const laborDisposalCostPerFilter = results.laborDisposalCostPerFilterPerYear;
        const totalCostPerFilter = filterCostPerFilter + energyCostPerFilter + laborDisposalCostPerFilter;
        
        const filterCostPercent = Math.round((filterCostPerFilter / totalCostPerFilter) * 100);
        const energyCostPercent = Math.round((energyCostPerFilter / totalCostPerFilter) * 100);
        const laborDisposalCostPercent = Math.round((laborDisposalCostPerFilter / totalCostPerFilter) * 100);
        
        // Create data table for Google Charts
        var data = google.visualization.arrayToDataTable([
          ['Cost Category', 'Amount per Filter per Year'],
          [`Filter Price - ${filterCostPercent}%`, filterCostPerFilter],
          [`Energy Cost - ${energyCostPercent}%`, energyCostPerFilter],
          [`Labor & Disposal - ${laborDisposalCostPercent}%`, laborDisposalCostPerFilter]
        ]);
        
        var options = {
          title: '',
          is3D: true,
          width: 600,
          height: 600,
          backgroundColor: 'transparent',
          chartArea: {
            left: 30,
            top: 30,
            width: '100%',
            height: '100%'
          },
          legend: {
            position: 'right',
            alignment: 'center',
            textStyle: {
              fontSize: 12,
              bold: true
            }
          },
          colors: ['#8BC34A', '#2196F3', '#F44336'],
          pieSliceText: 'percentage',
          pieSliceTextStyle: {
            fontSize: 16,
            bold: true,
            color: 'white'
          },
          tooltip: {
            text: 'both',
            textStyle: {
              fontSize: 14
            }
          },
          titleTextStyle: {
            fontSize: 18,
            bold: true,
            color: '#006738'
          }
        };
        
        var chart = new google.visualization.PieChart(document.getElementById('tco-pie-chart'));
        
        // Add ready event listener
        google.visualization.events.addListener(chart, 'ready', function() {
          console.log('Google Charts 3D pie chart rendered successfully');
        });
        
        // Add error event listener
        google.visualization.events.addListener(chart, 'error', function(err) {
          console.error('Google Charts error:', err);
        });
        
        chart.draw(data, options);
        
        // Store reference for PDF generation
        calculatorState.charts.tcoPieChart = chart;
        
        console.log('Google Charts 3D pie chart updated successfully');
      } catch (error) {
        console.error('Error updating Google Charts pie chart:', error);
      }
    }
    
    // Function to get the next available competitor number
    function getNextCompetitorNumber() {
      const existingNumbers = calculatorState.competitors.map(comp => comp.number);
      for (let i = 1; i <= 3; i++) {
        if (!existingNumbers.includes(i)) {
          return i;
        }
      }
      return 1; // Fallback, should not happen if max 2 competitors
    }

    // Function to add competitor form
    function addCompetitorForm(competitorNum) {
      console.log(`Adding competitor ${competitorNum} form`);
      
      const competitorId = `competitor-${competitorNum}`;
      const competitorFormsContainer = document.getElementById('competitor-forms-container');
      
      if (!competitorFormsContainer) {
        console.error('Competitor forms container not found');
        return;
      }
      
      // Create wrapper for side-by-side layout if this is the first competitor
      if (competitorNum === 1 && !document.querySelector('.competitor-forms-row')) {
        const competitorFormsRow = document.createElement('div');
        competitorFormsRow.className = 'competitor-forms-row';
        competitorFormsContainer.appendChild(competitorFormsRow);
      }
      
      const competitorForm = document.createElement('div');
      competitorForm.className = 'competitor-form';
      competitorForm.id = competitorId;
      
      competitorForm.innerHTML = `
        <div class="competitor-header">
          <h3>Competitor ${competitorNum} Filter Information</h3>
          <button type="button" class="remove-competitor" data-competitor-id="${competitorId}">&times;</button>
        </div>
        <div class="form-group">
          <label for="${competitorId}-model">Filter Model</label>
          <select id="${competitorId}-model-dropdown" class="form-control">
            <option value="">Select a model...</option>
            <option value="other">Other Model</option>
          </select>
          <input type="text" id="${competitorId}-model-text" class="form-control" value="Competitor ${competitorNum}" style="display: block;">
        </div>
        <div class="form-group">
          <label for="${competitorId}-size">Filter Size</label>
          <input type="text" id="${competitorId}-size" class="form-control" placeholder="Width x Height x Length (WxHxL)" value="">
        </div>
        <div class="form-group">
          <label for="${competitorId}-price">Filter Price ($)</label>
          <input type="number" id="${competitorId}-price" class="form-control" value="80" min="0" step="0.01">
        </div>
        <div class="form-group">
          <label for="${competitorId}-initial-pressure">Initial Pressure Drop (inches w.g.)</label>
          <input type="number" id="${competitorId}-initial-pressure" class="form-control" value="0.50" min="0" step="0.01">
        </div>
        <div class="form-group">
          <label for="${competitorId}-average-pressure">Average Pressure Drop (inches w.g.)</label>
          <input type="number" id="${competitorId}-average-pressure" class="form-control" value="0.78" min="0" step="0.01">
        </div>
        <div class="form-group">
          <label for="${competitorId}-lifespan">Filter Lifespan (months)</label>
          <input type="number" id="${competitorId}-lifespan" class="form-control" value="6" min="1" step="1">
        </div>
        <div class="form-group">
          <label for="${competitorId}-airflow">Filter Airflow Rate (CFM)</label>
          <input type="number" id="${competitorId}-airflow" class="form-control" value="2000" min="0" step="10">
        </div>
        <div class="form-group">
          <label for="${competitorId}-efficiency">Efficiency Rating</label>
          <input type="text" id="${competitorId}-efficiency" class="form-control" value="" placeholder="e.g., MERV-14, H13">
        </div>
      `;
      
      // Add to the appropriate container
      const competitorFormsRow = document.querySelector('.competitor-forms-row');
      if (competitorFormsRow) {
        competitorFormsRow.appendChild(competitorForm);
      } else {
        competitorFormsContainer.appendChild(competitorForm);
      }
      
      // Show the competitor forms container
      competitorFormsContainer.classList.remove('hidden');
      
      // Initialize dropdown for this competitor
      initCompetitorDropdown(competitorId);
      
      // Add remove button event listener
      const removeBtn = competitorForm.querySelector('.remove-competitor');
      removeBtn.addEventListener('click', () => {
        removeCompetitorForm(competitorId, competitorNum);
      });
      
      // Add competitor to state
      calculatorState.competitors.push({
        id: competitorId,
        number: competitorNum
      });
      
      console.log(`Competitor ${competitorNum} form added successfully`);
    }
    
    // Function to remove competitor form
    function removeCompetitorForm(competitorId, competitorNum) {
      console.log(`Removing competitor ${competitorNum} form`);
      
      const competitorForm = document.getElementById(competitorId);
      if (competitorForm) {
        competitorForm.remove();
      }
      
      // Remove from state
      calculatorState.competitors = calculatorState.competitors.filter(comp => comp.id !== competitorId);
      calculatorState.calculationResults.competitors = calculatorState.calculationResults.competitors.filter((comp, index) => index !== competitorNum - 1);
      
      // Hide container if no competitors
      if (calculatorState.competitors.length === 0) {
        const competitorFormsContainer = document.getElementById('competitor-forms-container');
        if (competitorFormsContainer) {
          competitorFormsContainer.classList.add('hidden');
        }
      }
      
      // Update comparison display
      if (calculatorState.competitors.length > 0) {
        updateComparisonDisplay();
      } else {
        // Hide comparison section if no competitors
        const competitorComparison = document.getElementById('competitor-comparison');
        if (competitorComparison) {
          competitorComparison.classList.add('hidden');
        }
      }
      
      console.log(`Competitor ${competitorNum} form removed successfully`);
    }
    
    // Function to calculate competitor LCC
    function calculateCompetitorLCC(competitorNum) {
      console.log(`Calculating LCC for competitor ${competitorNum}`);
      
      const competitorId = `competitor-${competitorNum}`;
      
      try {
        // Get competitor filter data
        const filterModelDropdown = document.getElementById(`${competitorId}-model-dropdown`);
        const filterModelText = document.getElementById(`${competitorId}-model-text`);
        const filterSize = document.getElementById(`${competitorId}-size`).value;
        const filterPrice = parseFloat(document.getElementById(`${competitorId}-price`).value);
        const initialPressureDrop = parseFloat(document.getElementById(`${competitorId}-initial-pressure`).value);
        const averagePressureDrop = parseFloat(document.getElementById(`${competitorId}-average-pressure`).value);
        const filterLifespan = parseFloat(document.getElementById(`${competitorId}-lifespan`).value);
        const airflowRate = parseFloat(document.getElementById(`${competitorId}-airflow`).value);
        const efficiencyRating = document.getElementById(`${competitorId}-efficiency`).value;
        
        // Get filter model name - prioritize text input if visible and has value, otherwise use dropdown
        let filterModel;
        if (filterModelText && filterModelText.style.display !== 'none' && filterModelText.value.trim()) {
          filterModel = filterModelText.value.trim();
        } else if (filterModelDropdown && filterModelDropdown.value && filterModelDropdown.value !== 'other') {
          filterModel = filterModelDropdown.value;
        } else {
          filterModel = `Competitor ${competitorNum}`;
        }
        
        // System parameters (same as AccuraFil)
        const numFilters = parseFloat(document.getElementById('num-filters').value);
        const operationHours = parseFloat(document.getElementById('operation-hours').value);
        const energyCost = parseFloat(document.getElementById('energy-cost').value);
        const laborCost = parseFloat(document.getElementById('labor-cost').value);
        const disposalCost = parseFloat(document.getElementById('disposal-cost').value);
        const fanEfficiency = parseFloat(document.getElementById('fan-efficiency').value);
        
        // Validate inputs
        if (isNaN(filterPrice) || isNaN(averagePressureDrop) || isNaN(filterLifespan) || 
            isNaN(airflowRate) || isNaN(numFilters) || isNaN(operationHours) || 
            isNaN(energyCost) || isNaN(laborCost) || isNaN(disposalCost) || isNaN(fanEfficiency)) {
          throw new Error(`Please fill in all required fields for ${competitorId} with valid numbers.`);
        }
        
        // Calculate filter changes per year
        const changesPerYear = 12 / filterLifespan;
        
        // Calculate filter cost per filter per year
        const filterCostPerFilterPerYear = filterPrice * changesPerYear;
        
        // Calculate energy cost per filter per year
        const cfmPerFilter = airflowRate;
        const pressureDropInWG = averagePressureDrop;
        const fanPowerHP = (cfmPerFilter * pressureDropInWG) / (6356 * fanEfficiency);
        const fanPowerKW = fanPowerHP * 0.746;
        const energyCostPerFilterPerYear = fanPowerKW * operationHours * energyCost;
        
        // Calculate labor and disposal cost per filter per year
        const laborDisposalCostPerFilterPerYear = (laborCost + disposalCost) * changesPerYear;
        
        // Calculate total cost per filter per year
        const totalCostPerFilterPerYear = filterCostPerFilterPerYear + energyCostPerFilterPerYear + laborDisposalCostPerFilterPerYear;
        
        // Calculate total cost for AHU per year
        const totalCostPerAHUPerYear = totalCostPerFilterPerYear * numFilters;
        
        const result = {
          filterModel,
          filterSize,
          filterPrice,
          changesPerYear,
          averagePressureDrop,
          filterCostPerFilterPerYear,
          energyCostPerFilterPerYear,
          laborDisposalCostPerFilterPerYear,
          totalCostPerFilterPerYear,
          totalCostPerAHUPerYear,
          numFilters,
          initialPressureDrop,
          filterLifespan,
          airflowRate,
          efficiencyRating
        };
        
        // Store the result in the correct position
        calculatorState.calculationResults.competitors[competitorNum - 1] = result;
        
        return result;
      } catch (error) {
        console.error(`Error calculating LCC for ${competitorId}:`, error);
        alert(`Error calculating LCC for competitor: ${error.message}`);
        return null;
      }
    }
    
    function updateComparisonDisplay() {
      console.log('Updating comparison display');
      
      const formatCurrency = (value) => value ? '$' + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : '$0.00';
      const formatNumber = (value, decimals = 2) => value ? value.toFixed(decimals) : '0.00';
      
      // Show the competitor comparison section
      const competitorComparison = document.getElementById('competitor-comparison');
      if (competitorComparison) {
        competitorComparison.classList.remove('hidden');
      }
      
      // Clear existing competitor rows
      const comparisonResultsBody = document.getElementById('comparison-results-body');
      while (comparisonResultsBody.firstChild) {
        comparisonResultsBody.removeChild(comparisonResultsBody.firstChild);
      }
      
      // Add Accurafil row first
      if (calculatorState.calculationResults.accurafil) {
        const accurafil = calculatorState.calculationResults.accurafil;
        const accurafilRow = document.createElement('tr');
        accurafilRow.innerHTML = `
          <td><strong>${accurafil.filterModel}</strong></td>
          <td>${formatCurrency(accurafil.filterPrice)}</td>
          <td>${formatNumber(accurafil.changesPerYear)}</td>
          <td>${formatNumber(accurafil.averagePressureDrop)}</td>
          <td>${formatCurrency(accurafil.energyCostPerFilterPerYear)}</td>
          <td>${formatCurrency(accurafil.laborDisposalCostPerFilterPerYear)}</td>
          <td>${formatCurrency(accurafil.totalCostPerFilterPerYear)}</td>
          <td>${formatCurrency(accurafil.totalCostPerAHUPerYear)}</td>
        `;
        comparisonResultsBody.appendChild(accurafilRow);
      }
      
      // Add competitor rows
      calculatorState.calculationResults.competitors.forEach(competitor => {
        if (competitor) {
          const competitorRow = document.createElement('tr');
          competitorRow.innerHTML = `
            <td><strong>${competitor.filterModel}</strong></td>
            <td>${formatCurrency(competitor.filterPrice)}</td>
            <td>${formatNumber(competitor.changesPerYear)}</td>
            <td>${formatNumber(competitor.averagePressureDrop)}</td>
            <td>${formatCurrency(competitor.energyCostPerFilterPerYear)}</td>
            <td>${formatCurrency(competitor.laborDisposalCostPerFilterPerYear)}</td>
            <td>${formatCurrency(competitor.totalCostPerFilterPerYear)}</td>
            <td>${formatCurrency(competitor.totalCostPerAHUPerYear)}</td>
          `;
          comparisonResultsBody.appendChild(competitorRow);
        }
      });
      
      updateSavingsText();
      
      if (typeof Chart !== 'undefined') {
        updateComparisonChart();
      }
      
      console.log('Comparison display updated');
    }
    
    // Function to update savings text
    function updateSavingsText() {
      console.log('Updating savings text');
      
      const savingsText = document.getElementById('savings-text');
      if (!savingsText || !calculatorState.calculationResults.accurafil) {
        return;
      }
      
      const accurafil = calculatorState.calculationResults.accurafil;
      let totalSavings = 0;
      let hasCompetitors = false;
      
      calculatorState.calculationResults.competitors.forEach(competitor => {
        if (competitor) {
          hasCompetitors = true;
          const savings = competitor.totalCostPerAHUPerYear - accurafil.totalCostPerAHUPerYear;
          totalSavings += savings;
        }
      });
      
      if (hasCompetitors) {
        const formatCurrency = (value) => '$' + Math.abs(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        
        if (totalSavings > 0) {
          savingsText.innerHTML = `You could save <strong>${formatCurrency(totalSavings)}</strong> per year by choosing AccuraFil over the competitors.`;
        } else if (totalSavings < 0) {
          savingsText.innerHTML = `AccuraFil costs <strong>${formatCurrency(totalSavings)}</strong> more per year than the competitors, but may provide better performance and reliability.`;
        } else {
          savingsText.innerHTML = `AccuraFil and the competitors have similar annual costs.`;
        }
      } else {
        savingsText.innerHTML = 'Calculate and compare with competitors to see potential savings.';
      }
    }
    
    // Function to update comparison chart with increased legend width
    function updateComparisonChart() {
      console.log('Updating comparison chart');
      
      try {
        const ctx = document.getElementById('comparison-chart');
        if (!ctx) {
          console.error('Comparison chart canvas not found');
          return;
        }
        
        // Destroy existing chart if it exists
        if (calculatorState.charts.comparisonChart) {
          calculatorState.charts.comparisonChart.destroy();
        }
        
        const labels = [];
        const filterCosts = [];
        const energyCosts = [];
        const laborDisposalCosts = [];
        
        // Add AccuraFil data
        if (calculatorState.calculationResults.accurafil) {
          const accurafil = calculatorState.calculationResults.accurafil;
          labels.push(accurafil.filterModel);
          filterCosts.push(accurafil.filterCostPerFilterPerYear);
          energyCosts.push(accurafil.energyCostPerFilterPerYear);
          laborDisposalCosts.push(accurafil.laborDisposalCostPerFilterPerYear);
        }
        
        // Add competitor data
        calculatorState.calculationResults.competitors.forEach(competitor => {
          if (competitor) {
            labels.push(competitor.filterModel);
            filterCosts.push(competitor.filterCostPerFilterPerYear);
            energyCosts.push(competitor.energyCostPerFilterPerYear);
            laborDisposalCosts.push(competitor.laborDisposalCostPerFilterPerYear);
          }
        });
        
        const chartData = {
          labels: labels,
          datasets: [
            {
              label: 'Filter Cost',
              data: filterCosts,
              backgroundColor: '#8BC34A',
              borderColor: '#689F38',
              borderWidth: 1
            },
            {
              label: 'Energy Cost',
              data: energyCosts,
              backgroundColor: '#2196F3',
              borderColor: '#1976D2',
              borderWidth: 1
            },
            {
              label: 'Labor & Disposal',
              data: laborDisposalCosts,
              backgroundColor: '#F44336',
              borderColor: '#D32F2F',
              borderWidth: 1
            }
          ]
        };
        
        const chartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              left: 10,   // Add left padding
              right: 40,  // Increase right padding for legend
              top: 10,    // Add top padding
              bottom: 40  // Add bottom padding for rotated labels
            }
          },
          scales: {
            x: {
              stacked: true,
              title: {
                display: true,
                text: 'Filter Models',
                font: {
                  size: 16,
                  weight: 'bold'
                }
              },
              categoryPercentage: 0.4, // Reduce category width to create more space
              barPercentage: 0.4, // Reduce bar width within category
              ticks: {
                autoSkip: false, // Prevent Chart.js from skipping labels
                maxRotation: 35, // Rotate labels by 45 degrees
                minRotation: 10, // Ensure labels are always rotated
                font: {
                  weight: 'bold'
                }
              }
            },
            y: {
              stacked: true,
              title: {
                display: true,
                text: 'Cost per Filter per Year ($)',
                font: {
                  size: 16,
                  weight: 'bold'
                }
              },
              ticks: {
                callback: function(value) {
                  return '$' + value.toFixed(0);
                }
              }
            }
          },
          plugins: {
            title: {
              display: true,
              text: 'Life-Cycle Cost Comparison',
              font: {
                size: 16,
                weight: 'bold'
              }
            },
            legend: {
              display: true,
              position: 'right',
              labels: {
                boxWidth: 20,  // Original box width
                padding: 15,   // Original padding
                font: {
                  size: 12,    // Original font size
                  weight: 'bold'
                },
                usePointStyle: true
              }
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  return context.dataset.label + ': $' + context.parsed.y.toFixed(2);
                }
              }
            }
          }
        };
        
        calculatorState.charts.comparisonChart = new Chart(ctx, {
          type: 'bar',
          data: chartData,
          options: chartOptions
        });
        
        console.log('Comparison chart updated successfully with increased legend width');
      } catch (error) {
        console.error('Error updating comparison chart:', error);
      }
    }
  }
});

// Function to initialize Competitor dropdown
function initCompetitorDropdown(competitorId) {
  const dropdown = document.getElementById(`${competitorId}-model-dropdown`);
  const modelTextInput = document.getElementById(`${competitorId}-model-text`);

  if (dropdown) {
    // Populate dropdown with model options
    Object.keys(accurafil_models_data).forEach(modelKey => {
      const option = document.createElement("option");
      option.value = modelKey;
      option.textContent = modelKey;
      dropdown.appendChild(option);
    });

    // Add event listener for dropdown change
    dropdown.addEventListener("change", function() {
      const selectedModel = this.value;
      if (selectedModel && accurafil_models_data[selectedModel]) {
        // Populate fields from selected AccuraFil model
        populateCompetitorFields(competitorId, accurafil_models_data[selectedModel]);
        modelTextInput.style.display = "none"; // Hide text input
        modelTextInput.value = selectedModel; // Set text input value to selected model
      } else if (selectedModel === "other") {
        // Show text input for custom model name
        modelTextInput.style.display = "block";
        modelTextInput.value = `Competitor ${competitorId.split('-')[1]}`;
        // Set default values for "other" option
        populateCompetitorFields(competitorId, {
          "Filter Size": "24\" x 24\" x 12\"",
          "Filter Price": 80,
          "Initial Pressure Drop": 0.50,
          "Average Pressure Drop": 0.78,
          "Filter Lifespan (months)": 6,
          "Filter Airflow Rate (CFM)": 2000,
          "Efficiency Rating": "MERV-14"
        });
      } else {
        // Clear fields if no model is selected
        modelTextInput.style.display = "block";
        modelTextInput.value = `Competitor ${competitorId.split('-')[1]}`;
        populateCompetitorFields(competitorId, {});
      }
    });
  }
}

// Function to populate competitor fields with selected model data
function populateCompetitorFields(competitorId, modelData) {
  const filterSizeField = document.getElementById(`${competitorId}-size`);
  const filterPriceField = document.getElementById(`${competitorId}-price`);
  const initialPressureDropField = document.getElementById(`${competitorId}-initial-pressure`);
  const averagePressureDropField = document.getElementById(`${competitorId}-average-pressure`);
  const filterLifespanField = document.getElementById(`${competitorId}-lifespan`);
  const airflowRateField = document.getElementById(`${competitorId}-airflow`);
  const efficiencyRatingField = document.getElementById(`${competitorId}-efficiency`);
  
  if (filterSizeField) { filterSizeField.value = modelData["Filter Size"] || ""; }
  if (filterPriceField) { filterPriceField.value = modelData["Filter Price"] || ""; }
  if (initialPressureDropField) { initialPressureDropField.value = modelData["Initial Pressure Drop"] || ""; }
  if (averagePressureDropField) { averagePressureDropField.value = modelData["Average Pressure Drop"] || ""; }
  if (filterLifespanField) { filterLifespanField.value = modelData["Filter Lifespan (months)"] || ""; }
  if (airflowRateField) { airflowRateField.value = modelData["Filter Airflow Rate (CFM)"] || ""; }
  if (efficiencyRatingField) { efficiencyRatingField.value = modelData["Efficiency Rating"] || ""; }
}

